/* FROMYHEART polish.js — behaviors for new sections.
   Vanilla JS, no dependencies, no jQuery, no theme globals. */
(function () {
  'use strict';

  /* ----- Announcement bar rotator ----- */
  function initAnnounce() {
    document.querySelectorAll('.fyh-announce').forEach(function (root) {
      var slides = root.querySelectorAll('.fyh-announce__slide');
      if (slides.length === 0) return;
      slides[0].classList.add('is-active');
      if (slides.length < 2) return;
      var i = 0;
      var interval = parseInt(root.dataset.interval || '4500', 10);
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    });
  }

  /**
   * Matches CartAddEvent shape from @theme/events so cart drawer, cart icon, and
   * cart-items-component receive section HTML and update without a full page reload.
   */
  function fyhAppendCartSections(formData) {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      ids.push(el.getAttribute('data-section-id'));
    });
    if (ids.length) {
      formData.set('sections', ids.join(','));
    }
    formData.set('sections_url', window.location.pathname + window.location.search);
  }

  function fyhDispatchCartUpdate(response, quantityAdded) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: 'fyh-polish',
          data: {
            source: 'product-form-component',
            itemCount: quantityAdded,
            sections: response.sections,
          },
        },
      })
    );
  }

  /**
   * @returns {Promise<object>}
   */
  function fyhPostAddToCart(formData, submitBtn) {
    var qty = parseInt(formData.get('quantity') || '1', 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    fyhAppendCartSections(formData);
    if (submitBtn) submitBtn.disabled = true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'text/html',
      },
      body: formData,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          if (submitBtn) submitBtn.disabled = false;
          return Promise.reject(new Error(response.message || 'Cart error'));
        }
        fyhDispatchCartUpdate(response, qty);
        return response;
      })
      .catch(function (err) {
        if (submitBtn) submitBtn.disabled = false;
        throw err;
      });
  }

  /* ----- Sticky mobile Add-to-Cart ----- */
  function initStickyAtc() {
    var bar = document.querySelector('.fyh-sticky-atc');
    if (!bar) return;
    var anchorSelector = bar.dataset.anchor || '.fyh-pdp-atc-anchor';
    var anchor = document.querySelector(anchorSelector);
    if (!anchor) {
      bar.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) bar.classList.remove('is-visible');
        else bar.classList.add('is-visible');
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    io.observe(anchor);
  }

  /* ----- PDP sticky bar: AJAX add (same as theme product form) ----- */
  function initFyhStickyAtcForm() {
    var form = document.querySelector('form.fyh-sticky-atc');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var labelEl = btn ? btn.querySelector('.fyh-sticky-atc__btn-label') : null;
      var originalLabel = labelEl ? labelEl.textContent : btn ? btn.textContent : '';
      if (labelEl) labelEl.textContent = 'Adding…';
      else if (btn) btn.textContent = 'Adding…';

      fyhPostAddToCart(new FormData(form), btn)
        .then(function () {
          if (labelEl) labelEl.textContent = 'Added ✓';
          else if (btn) btn.textContent = 'Added ✓';
          setTimeout(function () {
            if (labelEl) labelEl.textContent = originalLabel;
            else if (btn) btn.textContent = originalLabel;
            if (btn) btn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          if (labelEl) labelEl.textContent = originalLabel;
          else if (btn) btn.textContent = originalLabel;
          if (btn) btn.disabled = false;
          /* FB/Instagram in-app browsers sometimes block fetch — fall back to normal form POST */
          if (typeof form.submit === 'function') form.submit();
        });
    });
  }

  /* ----- Quick add on collection grids (uses Shopify /cart/add.js) ----- */
  function initQuickAdd() {
    document.querySelectorAll('[data-fyh-quickadd]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          window.location.href = btn.getAttribute('data-product-url') || '#';
          return;
        }
        var originalHtml = btn.innerHTML;
        var label = btn.querySelector('.fyh-card__atc-label');
        if (label) label.textContent = 'Adding…';
        else btn.textContent = 'Adding…';

        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');

        fyhPostAddToCart(fd, btn)
          .then(function () {
            if (label) label.textContent = 'Added ✓';
            else btn.textContent = 'Added ✓';
            setTimeout(function () {
              btn.innerHTML = originalHtml;
              btn.disabled = false;
            }, 1400);
          })
          .catch(function () {
            var fallbackUrl = btn.getAttribute('data-product-url');
            if (fallbackUrl) {
              window.location.href = fallbackUrl;
              return;
            }
            if (label) label.textContent = 'Try again';
            else btn.textContent = 'Try again';
            setTimeout(function () {
              btn.innerHTML = originalHtml;
              btn.disabled = false;
            }, 1500);
          });
      });
    });
  }

  /* ----- Shop-the-look hotspot click-to-toggle (mobile) ----- */
  function initHotspots() {
    document.querySelectorAll('.fyh-look__hotspot').forEach(function (spot) {
      spot.addEventListener('click', function (e) {
        e.preventDefault();
        var tip = spot.nextElementSibling;
        if (tip && tip.classList.contains('fyh-look__tooltip')) {
          tip.style.display = tip.style.display === 'block' ? 'none' : 'block';
        }
      });
    });
  }

  /* ----- FAQ keeps native <details> behavior; nothing to do ----- */

  /* ----- Shop-the-Look CAROUSEL (zula-style, prev/next + dots) ----- */
  function initLooksCarousel() {
    document.querySelectorAll('[data-fyh-looks]').forEach(function (root) {
      var viewport = root.querySelector('[data-fyh-looks-viewport]');
      var prev = root.querySelector('[data-fyh-looks-prev]');
      var next = root.querySelector('[data-fyh-looks-next]');
      var dotsWrap = root.querySelector('[data-fyh-looks-dots]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fyh-look-slide]'));
      if (!viewport || slides.length === 0) return;

      var current = 0;
      var scrollTimer = null;

      function clamp(n) { return Math.max(0, Math.min(slides.length - 1, n)); }

      function goTo(idx, behavior) {
        idx = clamp(idx);
        var target = slides[idx];
        if (!target) return;
        viewport.scrollTo({ left: target.offsetLeft, behavior: behavior || 'smooth' });
        current = idx;
        updateUI();
      }

      function updateUI() {
        if (prev) prev.toggleAttribute('disabled', current <= 0);
        if (next) next.toggleAttribute('disabled', current >= slides.length - 1);
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            dot.classList.toggle('is-active', i === current);
          });
        }
      }

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Go to look ' + (i + 1));
          dot.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(dot);
        });
      }

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });

      viewport.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var nearest = 0;
          var minDist = Infinity;
          slides.forEach(function (s, i) {
            var d = Math.abs(s.offsetLeft - viewport.scrollLeft);
            if (d < minDist) { minDist = d; nearest = i; }
          });
          if (nearest !== current) {
            current = nearest;
            updateUI();
          }
        }, 90);
      }, { passive: true });

      updateUI();
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ----- Video Shop (autoplay-in-view + sound toggle) ----- */
  function initVideoShop() {
    var sections = document.querySelectorAll('[data-fyh-video-shop]');
    if (!sections.length) return;

    var allVideos = document.querySelectorAll('[data-fyh-video]');
    if (!allVideos.length) return;

    var supportsIO = 'IntersectionObserver' in window;
    var supportsRM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var prefersData = navigator.connection && navigator.connection.saveData;

    function tryPlay(v) {
      if (!v.paused) return;
      var p = v.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    }

    if (supportsRM || prefersData) {
      // Honor reduced-motion / data-saver: keep videos paused, show poster.
      Array.prototype.forEach.call(allVideos, function (v) { try { v.pause(); } catch(e){} });
    } else if (supportsIO) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload !== 'auto') v.preload = 'auto';
            tryPlay(v);
          } else {
            try { v.pause(); } catch(e){}
          }
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });

      Array.prototype.forEach.call(allVideos, function (v) { io.observe(v); });
    } else {
      Array.prototype.forEach.call(allVideos, function (v) { tryPlay(v); });
    }

    // Sound toggle: only one video can be unmuted at a time.
    var soundButtons = document.querySelectorAll('[data-fyh-video-sound]');
    Array.prototype.forEach.call(soundButtons, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card  = btn.closest('[data-fyh-video-card]');
        var video = card && card.querySelector('[data-fyh-video]');
        if (!video) return;

        if (video.muted) {
          // Mute everyone else
          Array.prototype.forEach.call(allVideos, function (v) {
            v.muted = true;
            var c = v.closest('[data-fyh-video-card]');
            if (c) c.removeAttribute('data-unmuted');
          });
          video.muted = false;
          card.setAttribute('data-unmuted', 'true');
          tryPlay(video);
        } else {
          video.muted = true;
          card.removeAttribute('data-unmuted');
        }
      });
    });
  }

  function initHeavySections() {
    initLooksCarousel();
    initVideoShop();
  }

  ready(function () {
    initAnnounce();
    initStickyAtc();
    initFyhStickyAtcForm();
    initQuickAdd();
    initHotspots();
    // Carousel + video observers are not needed for first input; defer to idle to reduce main-thread contention (INP).
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(
        function () {
          initHeavySections();
        },
        { timeout: 2200 }
      );
    } else {
      window.setTimeout(initHeavySections, 0);
    }
  });
})();
